import { render, staticRenderFns } from "./RowStandard.vue?vue&type=template&id=2195e3b6&scoped=true"
import script from "./RowStandard.vue?vue&type=script&lang=js"
export * from "./RowStandard.vue?vue&type=script&lang=js"
import style0 from "./RowStandard.vue?vue&type=style&index=0&id=2195e3b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195e3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2195e3b6')) {
      api.createRecord('2195e3b6', component.options)
    } else {
      api.reload('2195e3b6', component.options)
    }
    module.hot.accept("./RowStandard.vue?vue&type=template&id=2195e3b6&scoped=true", function () {
      api.rerender('2195e3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingAdjustmentManagement/components/RowStandard.vue"
export default component.exports